<template>
  <ListItemContainer
    :data="localData"
    :is-nested="isNested"
    :is-loading="isLoading"
    class="list-item-container"
    @publish="handlePublish"
    @update="handleUpdate"
    @delete="handleDelete"
  >
    <template #answers="props">
      <QaListItem v-bind="{ ...props, parentId: data.id }" />
    </template>
  </ListItemContainer>
</template>

<script>
import ListItemContainer from "@/components/QuestionsAndAnswers/QaListItemContainer.vue";
import QAndAServiceManager from "@/helpers/q-and-a-service-manager.js";
import { GTM_EVENT_NAME } from "@/enums/gtm-events";

export default {
  name: "QaListItem",
  components: {
    ListItemContainer
  },
  props: {
    isNested: {
      type: Boolean,
      default: false
    },
    parentId: {
      type: Number
    },
    data: {
      type: Object,
      validator: function(value) {
        return value && "gmb_author" in value && "text" in value;
      }
    }
  },
  data() {
    return {
      localData: null,
      serviceManager: null,
      isLoading: false
    };
  },
  computed: {
    isAnswer() {
      return !("gmb_answers" in this.data);
    }
  },
  created() {
    this.serviceManager = new QAndAServiceManager(this.isAnswer);
  },
  methods: {
    async handlePublish(data) {
      this.isLoading = true;

      const result = await this.serviceManager.create({
        questionId: this.data.id,
        text: data,
        facility: this.data.facility
      });
      this.$gtm.trackCustomEvent({
        event: GTM_EVENT_NAME.QA_ADDED_ANSWER
      });
      this.localData.gmb_answers.push(result);
      this.isLoading = false;
    },
    async handleUpdate(data) {
      const localDataTextTmp = this.localData.text;

      this.localData.text = data;
      try {
        await this.serviceManager.update(this.data.id, { text: data });
        this.$gtm.trackCustomEvent({
          event: this.isAnswer
            ? GTM_EVENT_NAME.QA_EDITED_ANSWER
            : GTM_EVENT_NAME.QA_EDITED_QUESTION
        });
      } catch (e) {
        this.localData.text = localDataTextTmp;
      }
    },
    async handleDelete() {
      await this.serviceManager.delete(this.data.id);
      this.$store.dispatch("questionsAndAnswers/deleteQuestion", {
        parentId: this.parentId,
        elementId: this.data.id
      });
    }
  },
  watch: {
    isLoading: function(val) {
      this.isLocalLoading = val;
    },
    data: {
      handler: function(val) {
        this.localData = val;
      },
      immediate: true
    }
  }
};
</script>
